var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalibrationFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.2415L10.5 3.2585V12.8333H0V0ZM6.70833 1.16667V3.79167H9.33333L6.70833 1.16667Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibrationFileIcon);
export default __webpack_public_path__ + "static/media/calibration_file_icon.4788a2ff0f2fdc84087711df6283f3f8.svg";
export { ForwardRef as ReactComponent };